import { Megaphone } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMegaphone12Line = createIcon(Megaphone, 12, "Line");
export const IconMegaphone16Line = createIcon(Megaphone, 16, "Line");
export const IconMegaphone20Line = createIcon(Megaphone, 20, "Line");
export const IconMegaphone24Line = createIcon(Megaphone, 24, "Line");
export const IconMegaphone32Line = createIcon(Megaphone, 32, "Line");
export const IconMegaphone48Line = createIcon(Megaphone, 48, "Line");
export const IconMegaphone64Line = createIcon(Megaphone, 64, "Line");
